import { useQuery } from "@tanstack/react-query";

import { listVersionReviews } from "services";

import { LIST_VERSION_REVIEWS } from "consts";

export const useVersionReviews = () =>
  useQuery({
    queryKey: [LIST_VERSION_REVIEWS],
    queryFn: listVersionReviews,
  });
